import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { menuStructure } from '../data/menuStructure';
import "./Layout.css";

const Layout = () => {
  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [sidebarWidth, setSidebarWidth] = useState(280);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();

  // 현재 경로에 따라 사이드바 표시 여부 결정
  useEffect(() => {
    const currentPath = location.pathname;
    let shouldShowSidebar = false;

    // 현재 경로에 해당하는 메인 메뉴 찾기
    Object.entries(menuStructure).forEach(([menuKey, menu]) => {
      if (currentPath.startsWith(menu.path) && menu.path !== '/') {
        // 서브메뉴가 있는 경우에만 사이드바 표시
        if (menu.submenus && menu.submenus.length > 0) {
          shouldShowSidebar = true;
        }
      }
    });

    // 홈페이지면 사이드바 숨김
    if (currentPath === '/') {
      shouldShowSidebar = false;
    }

    setSidebarVisible(shouldShowSidebar);
  }, [location.pathname]);

  // 사이드바 토글
  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  // 사이드바 완전히 숨기기
  const hideSidebar = () => {
    setSidebarVisible(false);
  };

  return (
    <div className="app-layout">
      {/* 헤더 */}
      <Header onToggleSidebar={toggleSidebar} />
      
      {/* 메인 컨테이너 */}
      <div className="main-container">
        {/* 사이드바 */}
        {sidebarVisible && (
          <div className={`sidebar-container ${isCollapsed ? 'collapsed' : ''}`}>
            <Sidebar 
              isCollapsed={isCollapsed}
              onHide={hideSidebar}
              onToggle={toggleSidebar}
            />
          </div>
        )}
        
        {/* 메인 콘텐츠 */}
          <main 
            className={`main-content ${sidebarVisible ? 'with-sidebar' : 'full-width'} ${isCollapsed ? 'sidebar-collapsed' : ''}`}
          >
            <div>
              <Outlet />
            </div>
          </main>
      </div>
    </div>
  );
};

export default Layout;